/** @internal */
export const HORIZONTAL = 'horizontal';
/** @internal */
export const VERTICAL = 'vertical';
/** @internal */
export const TOP = 'top';
/** @internal */
export const BOTTOM = 'bottom';
/** @internal */
export const LEFT = 'left';
/** @internal */
export const RIGHT = 'right';
/** @internal */
export const MIDDLE = 'middle';
/** @internal */
export const END = 'end';
/** @internal */
export const START = 'start';
/** @internal */
export const LINEAR = 'linear';
/** @internal */
export const BAND = 'band';
/** @internal */
export const ARGUMENT_DOMAIN = 'argument-domain';
/** @internal */
export const VALUE_DOMAIN = 'value-domain';
/** @internal */
export const HOVERED = 'hovered';
/** @internal */
export const SELECTED = 'selected';
/** @internal */
export const DIFFERENCE = 3;
